import { Outlet, RouteObject } from 'react-router-dom';
import { AccountDetailsPage } from './superpay/account-details/AccountDetailsPage';
import { BankAccountPage } from './superpay/bank-account/BankAccountPage';
import { BusinessDetailsPage } from './superpay/business-details/BusinessDetailsPage';
import { PromoPage } from './superpay/promo/PromoPage';
import { getSuperPayProfilePathsByStatus } from './superpay/getSuperPayPathsByStatus';
import {
  SuperPayRoute,
  SUPERPAY_PROFILE_ROUTES,
} from './superpay/SuperPayRoute';
import { PermissionView } from 'shared/modules/permission/core/PermissionView';

export const superPayRoutes: RouteObject[] = [
  {
    path: 'superpay',
    element: (
      <PermissionView name="superpay" permission="can_view">
        <Outlet />
      </PermissionView>
    ),
    children: [
      {
        path: 'onboarding',
        children: [
          {
            path: 'create-account',
            element: (
              <SuperPayRoute
                path={SUPERPAY_PROFILE_ROUTES.businessDetails}
                getPathByStatus={getSuperPayProfilePathsByStatus}
              >
                <BusinessDetailsPage />
              </SuperPayRoute>
            ),
          },
          {
            path: 'bank-account',
            element: (
              <SuperPayRoute
                path={SUPERPAY_PROFILE_ROUTES.bankDetails}
                getPathByStatus={getSuperPayProfilePathsByStatus}
              >
                <BankAccountPage />
              </SuperPayRoute>
            ),
          },
          {
            path: 'account-details/:page?',
            element: (
              <SuperPayRoute
                path={SUPERPAY_PROFILE_ROUTES.accountDetails}
                getPathByStatus={getSuperPayProfilePathsByStatus}
              >
                <AccountDetailsPage />
              </SuperPayRoute>
            ),
          },
        ],
      },
      {
        index: true,
        element: (
          <SuperPayRoute
            path={SUPERPAY_PROFILE_ROUTES.promo}
            getPathByStatus={getSuperPayProfilePathsByStatus}
          >
            <PromoPage />
          </SuperPayRoute>
        ),
      },
    ],
  },
];
